<template>
  <form-section
    :direction="direction"
    :error="error"
    :hint="hint"
    :label="label"
    :name="name"
  >
    <div class="select-input">
      <select
        ref="input"
        :name="name"
        :disabled="isDisabled"
        :id="name"
        class="select-input__input"
        @input="handleInputValue"
      >
        <option
          v-if="emptyLabel"
          value=""
        >
          {{ emptyLabel }}
        </option>

        <optgroup
          v-for="group in options"
          :label="group.name"
          :key="group.name"
        >
          <option
            v-for="option in group.entries"
            :disabled="option.isDisabled"
            :value="option.value"
            :key="option.value"
          >
            {{ option.label }}
          </option>
        </optgroup>
      </select>
      <font-awesome-icon
        class="select-input__arrow"
        icon="angle-down"
      />
    </div>
  </form-section>
</template>

<script>
import findIndex from 'lodash.findindex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import InputCommon from './InputCommon'

export default {
  name: 'GroupedSelectInput',
  mixins: [InputCommon],
  components: {
    FontAwesomeIcon
  },
  props: {
    options: {
      // Format: [{label: 'Germany', value: 'De'}, ...]
      type: Array,
      required: true
    },
    emptyLabel: {
      type: String,
      default: () => 'Auswahl …'
    },
    value: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    fieldClasses () {
      return [
        { 'field__input--disabled': this.isDisabled }
      ]
    }
  },
  watch: {
    value () {
      this.setInputValue()
    },
    options () {
      this.setInputValue()
    }
  },
  methods: {
    setInputValue () {
      const input = this.$refs.input
      if (input && this.options.length > 0) {
        let selectedOption = input.options[input.selectedIndex]
        if (!selectedOption || this.value !== selectedOption.value) {
          const index = findIndex(input.options, option => {
            return option.value === this.value
          })
          input.selectedIndex = index
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => this.setInputValue())
  }
}
</script>

<style lang="sass">
@import '~styles/imports'
@import '~styles/forms/mixins'

.select-input__input
  @extend %form-text-input-style
  cursor: pointer

.select-input__arrow
  color: $color-grey-2
  pointer-events: none
  position: absolute
  right: 13px
  top: 22px

</style>



// WEBPACK FOOTER //
// src/components/forms/GroupedSelectInput.vue